var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-widget-edit"},[_c('menu-item',{attrs:{"label":"背景设置"}},[_c('menu-background-image',{attrs:{"target":_vm.model.background,"target-key":"background"}}),_vm._v(" "),_c('menu-fill',{staticClass:"mt-2",attrs:{"target":_vm.model.background,"target-key":"background"}})],1),_vm._v(" "),_c('remove-btn',{staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }